//
//
//
//

export default {
  name: 'box',
  props: {
    gap: String
  }
}
